<template>
    <div>
        <ListSearch ref="listSearch" :formSearch="formSearch">
            <template #buttons>
                <el-button type="primary" @click="addItem">新建用户</el-button>
            </template>
            <template #forms>
                <el-form-item label="用户类型">
                    <el-select
                        v-model="formSearch.type"
                        @change="$refs.listSearch.search()"
                        placeholder="请选择用户类型"
                        clearable
                    >
                        <el-option
                            v-for="(item, index) in typeList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                            clearable
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="客户">
                    <el-select
                        v-model="formSearch.companyId"
                        @change="$refs.listSearch.search()"
                        placeholder="请选择客户"
                        clearable
                    >
                        <el-option
                            v-for="(item, index) in companyList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                            clearable
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户角色">
                    <el-select
                        v-model="formSearch.role"
                        @change="$refs.listSearch.search()"
                        placeholder="请选择用户角色"
                        clearable
                    >
                        <el-option
                            v-for="(item, index) in roleList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                            clearable
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户姓名">
                    <el-input
                        v-model="formSearch.userName"
                        placeholder="请输入用户姓名"
                        @change="$refs.listSearch.search()"
                        clearable
                    ></el-input>
                </el-form-item>
                <div class="buttons">
                    <el-button type="primary" @click="$refs.listSearch.search()">查询</el-button>
                    <el-button @click="$refs.listSearch.reset()">重置</el-button>
                </div>
            </template>
            <template #list="{tableData, loading}">
                <el-table :data="tableData" border v-loading="loading">
                    <el-table-column
                        align="center"
                        v-for="(item, index) in tableKey"
                        :key="index"
                        :label="item.label"
                        :width="item.width"
                    >
                        <template slot-scope="scope"
                        >{{ item.myFilter ? item.myFilter(scope.row[item.prop]) : scope.row[item.prop] }}</template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="250">
                        <template slot-scope="scope"  v-if="scope.row.status!='DELETED'">
                            <div class="my-button" @click="resetPwd(scope.row)">
                                <i class="iconfont iconlogin_lock"></i>重置密码
                            </div>
                            <div class="my-button" @click="editItem(scope.row)">
                                <i class="iconfont iconedit"></i>修改
                            </div>
                            <div class="my-button" @click="deleteItem(scope.row)">
                                <i class="iconfont icontrash"></i>删除
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </ListSearch>
        <EditDialog
            :dialogShow.sync="editDialogShow"
            :formData="editDialogData"
            :companyList="companyList"
            @updateData="$refs.listSearch.updateData()"
        ></EditDialog>
    </div>
</template>

<script>
import ListSearch from '@/components/ListSearch/ListSearch';
import EditDialog from './components/EditDialog';
export default {
    data() {
        return {
            editDialogShow: false, // 编辑弹窗是否显示
            editDialogData: null, // 编辑弹窗表单数据
            tableKey: [
                {
                    prop: 'userName',
                    label: '姓名'
                },
                {
                    prop: 'loginName',
                    label: '账号'
                },
                {
                    prop: 'roleName',
                    label: '角色'
                },
                {
                    prop: 'sexName',
                    label: '性别'
                },
                {
                    prop: 'mobile',
                    label: '联系方式'
                },
                {
                    prop: 'statusName',
                    label: '状态'
                },
                {
                    prop: 'lastLoginTime',
                    label: '最后登录时间'
                }
            ],
            formSearch: {
                type: '',
                companyId: '',
                userName: '',
                roleId: ''
            },
            roleList: [], // 角色列表
            typeList: [], // 公司类型列表
            companyList: [], // 养护单位列表
            companyShow: false // 养护单位选择框显示与否
        };
    },
    components: {
        ListSearch,
        EditDialog
    },
    created() {
        this.getTypeList();
        this.getCompanyList();
        this.getRoleList();
    },
    mounted() {
        this.$refs.listSearch.search();
    },
    methods: {
        getList(page, size) {
            return this.$http.get('/account/page/v1', {
                ...this.formSearch,
                page,
                size
            });
        },
        // 获取公司类型列表
        getTypeList() {
            this.$http.get('/company/type-list-all/v1').then(res => {
                this.typeList = res;
            });
        },
        // 获取养护单位列表
        getCompanyList() {
            this.$http
                .get('/company/company-all/v1')
                .then(res => {
                    this.companyList = res;
                });
        },
        // 获取角色清单
        getRoleList() {
            this.$http.get('/account/roles/v1').then(res => {
                this.roleList = res;
            });
        },
        // 改变用户类型时
        // changeUserType(val) {
        //     switch (val) {
        //         case 'SUPERVISOR':
        //         case 'COMPANY':
        //             this.companyShow = true;
        //             break;
        //         case 'GOVERNMENT':
        //         default:
        //             this.formSearch.companyId = '';
        //             this.companyShow = false;
        //     }
        //     this.formSearch.roleId = '';
        //     this.$refs.listSearch.search();
        // },
        // 新建
        addItem() {
            this.editDialogData = null;
            this.editDialogShow = true;
        },
        // 编辑
        editItem(item) {
            this.editDialogData = item;
            this.editDialogShow = true;
        },
        // 重置密码
        resetPwd(item) {
            this.$confirm('确认重置密码吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.$http.put('/account/resetpassword/v1', {
                    userId: item.userId
                }, '提交中……', '重置成功')
            })
        },
        // 删除
        deleteItem(item) {
            this.$confirm('确认删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.$http
                    .delete(
                        '/account/delete/v1',
                        {
                            userId: item.userId
                        },
                        '提交中……',
                        '删除成功'
                    )
                    .then(() => {
                        this.$refs.listSearch.updateData();
                    });
            });
        }
    }
};
</script>